module.exports = __webpack_public_path__ + "static/media/icon-pix.f7d33c5f.png";